export function sharedUtilsPipes(): string {
  return 'shared-utils-pipes';
}
